import { redirect } from "@tanstack/react-router";
import { authClient } from "@/lib/auth-client";

type PbosRole = "admin" | "project_manager" | "supervisor" | "contractor";

export async function requireAuth() {
  const session = await authClient.getSession();
  if (!session.data) throw redirect({ to: "/login" });
  return session.data;
}

export async function requireAdmin() {
  const session = await requireAuth();
  if (session.user.role !== "admin") throw redirect({ to: "/" });
  return session;
}

/**
 * Require any of the specified roles. Redirects to /dashboard if the user
 * doesn't have one of the allowed roles.
 */
export function requireRole(allowedRoles: PbosRole[]) {
  return async () => {
    const session = await requireAuth();
    if (!allowedRoles.includes(session.user.role as PbosRole)) {
      throw redirect({ to: "/" });
    }
    return session;
  };
}

/**
 * Deny specific roles from accessing a route. Redirects to /dashboard
 * if the user has one of the denied roles.
 */
export function denyRole(deniedRoles: PbosRole[]) {
  return async () => {
    const session = await requireAuth();
    if (deniedRoles.includes(session.user.role as PbosRole)) {
      throw redirect({ to: "/" });
    }
    return session;
  };
}
